import { render, staticRenderFns } from "./CaseTaskRunHistory.vue?vue&type=template&id=2c58b7bf"
import script from "./CaseTaskRunHistory.vue?vue&type=script&lang=js"
export * from "./CaseTaskRunHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports